import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import { FeaturesLayoutUI } from '../../merch-card/features-display/FeaturesLayoutUI';
import ChecklistItemTranslated from '../ChecklistItemTranslated';
// @ts-expect-error svg import
import DefaultCreditsCalloutImage from 'bender-url!../../../img/creditsCallout/generic.svg';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { useHistory } from 'react-router-dom';
import { CREDITS_CALLOUT } from '../../../constants/tracking/TrackingSources';
import { CREDITS_RELATED_FEATURES, getHubSpotCreditsKeyFeatures } from '../../../utils/getHubSpotCreditsKeyFeatures';
import { trackClickedLink } from '../../../utils/tracking/trackingEventUtils';
import { useHighestProductLevelFromInventory } from '../../../v2/hooks/useProductInventory';
import { getCustomerAgentCalloutImage, getDataAgentCalloutImage, getDataStudioCalloutImage, getProspectingAgentCalloutImage } from '../../key-features/getLocalizedImages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCreditsCalloutImage = navItem => {
  switch (navItem) {
    case NavItemEnum.SUITE:
    case NavItemEnum.MARKETING_PLUS:
    case NavItemEnum.MARKETING:
    case NavItemEnum.SERVICE:
    case NavItemEnum.CONTENT:
    case NavItemEnum.COMMERCE:
      return getCustomerAgentCalloutImage();
    case NavItemEnum.DATA:
      return getDataStudioCalloutImage();
    case NavItemEnum.SALES:
      return getProspectingAgentCalloutImage();
    case NavItemEnum.FREE:
      return getDataAgentCalloutImage();
    default:
      return DefaultCreditsCalloutImage;
  }
};
export const CreditsCallout = ({
  navItem
}) => {
  const history = useHistory();
  const {
    highestProductLevel
  } = useHighestProductLevelFromInventory();
  const isFreeOrProspect = highestProductLevel === 'FREE';
  const isTabletPortrait = useMedia('tabletPortrait');
  const creditsCalloutImage = getCreditsCalloutImage(navItem);
  const features = navItem === NavItemEnum.SUITE // Suite has a different set of key features compared to HC page
  ? [CREDITS_RELATED_FEATURES.customerAgent, CREDITS_RELATED_FEATURES.dataAgent, CREDITS_RELATED_FEATURES.buyerIntent, CREDITS_RELATED_FEATURES.breezeActionsWorkflows] : getHubSpotCreditsKeyFeatures(navItem);
  const FeaturesListSection = features.map((feature, index) => {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: index > 0 ? '200' : undefined,
      children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.title`
        })
      })
    }, feature);
  });
  const handleClick = () => {
    const url = isFreeOrProspect ? `/hubspot-credits?tab=${navItem}` : '/hubspot-credits';
    trackClickedLink({
      name: 'learn-more-hubspot-credits-link',
      type: 'internal',
      url,
      trackingSource: CREDITS_CALLOUT
    });
    history.push(url);
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    borderRadius: "300",
    blockSize: "100%",
    marginBlock: "0",
    maxBlockSize: isTabletPortrait ? '100%' : '436px',
    overflow: "hidden",
    children: /*#__PURE__*/_jsxs(CardSection, {
      padding: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: isTabletPortrait ? 'column-reverse' : 'row',
      children: [/*#__PURE__*/_jsx(View, {
        flex: "1",
        padding: "1000",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-25",
              padding: "0",
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.pages.hubspot-credits.creditsCallout.heading"
              })
            }), /*#__PURE__*/_jsx(Text, {
              typography: "heading-400",
              color: "text-core-default",
              padding: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `pricingPage.pages.hubspot-credits.creditsCallout.title.${navItem}`
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "300",
            marginBlockEnd: "600",
            children: /*#__PURE__*/_jsx(FeaturesLayoutUI, {
              loading: false,
              FeaturesListSection: FeaturesListSection
            })
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "fit-content",
            children: /*#__PURE__*/_jsx(Button, {
              use: "tertiary",
              borderColor: "border-core-default",
              borderWidth: "100",
              borderStyle: "solid",
              onClick: handleClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricingPage.pages.hubspot-credits.creditsCallout.cta"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        flex: "2",
        paddingBlockStart: "1000",
        blockSize: "100%",
        alignSelf: "end",
        paddingInline: isTabletPortrait ? '600' : '0',
        children: /*#__PURE__*/_jsx(Image, {
          src: creditsCalloutImage,
          alt: "Credits Callout Placeholder image"
        })
      })]
    })
  });
};